import { createContext, useContext, useEffect } from 'react';

// WCAG 2.4.2: every view gets its own title — "<view> – zencera".
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} – zencera` : 'zencera';
  }, [title]);
}

export type Announce = (message: string) => void;
export const AnnounceContext = createContext<Announce>(() => {});

export function useAnnounce(): Announce {
  return useContext(AnnounceContext);
}
